import { OTCSettlementTypeEnum, PayoffTypeEnum, StrikeTypeEnum } from '@talos/kyoko';

/**
 * Valid payoff types for forward products.
 */
export const FORWARD_PAYOFF_TYPE_OPTIONS = [
  { value: PayoffTypeEnum.Inverse, label: PayoffTypeEnum.Inverse },
  { value: PayoffTypeEnum.Linear, label: PayoffTypeEnum.Linear },
];
export const FORWARD_PAYOFF_TYPES = FORWARD_PAYOFF_TYPE_OPTIONS.map(option => option.value);

/**
 * Valid settlement types for forward products.
 */
export const OTC_SETTLEMENT_TYPE_OPTIONS = [
  { value: OTCSettlementTypeEnum.Cash, label: OTCSettlementTypeEnum.Cash },
  { value: OTCSettlementTypeEnum.Physical, label: OTCSettlementTypeEnum.Physical },
];
export const OTC_SETTLEMENT_TYPES = OTC_SETTLEMENT_TYPE_OPTIONS.map(option => option.value);

/**
 * Valid strike types for option products.
 */
export const OPTION_STRIKE_TYPE_OPTIONS = [
  { value: StrikeTypeEnum.Fixed, label: StrikeTypeEnum.Fixed },
  { value: StrikeTypeEnum.Delta, label: StrikeTypeEnum.Delta },
];

/**
 * Valid exercise styles for option products.
 * For 2.54, only European is supported.
 */
export type ExerciseStyleOption = { value: 'European' | 'American'; label: 'European' | 'American' };
export const OPTION_EXERCISE_STYLE_OPTIONS: ExerciseStyleOption[] = [{ value: 'European', label: 'European' }];
